/**
 * useAuth - hook wrapper around AuthContext for consumer convenience.
 * Isolated to keep provider file lean for React Fast Refresh.
 */
import { useContext } from 'react';
import { AuthContext } from './AuthContextInternal';

export function useAuth(){
  const ctx = useContext(AuthContext);
  if(!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
